import { useEffect, useState } from 'react';
import { Channel, PresenceChannel } from 'pusher-js';

import { useChannels } from './useChannels';

export function useChannel<T extends Channel & PresenceChannel>(
  channelName: string | undefined,
) {
  const [channel, setChannel] = useState<Channel & PresenceChannel>();
  const { subscribe, unsubscribe } = useChannels();

  useEffect(() => {
    if (!channelName || !subscribe || !unsubscribe) return;

    const _channel = subscribe<T>(channelName);
    setChannel(_channel);
    return () => unsubscribe(channelName);
  }, [channelName, subscribe, unsubscribe]);

  return channel;
}
